import { Input } from "@amzn/awsui-components-react";
import { AuditNameProps } from "./definitions";
import FormField from "@amzn/awsui-components-react/polaris/form-field";
import { getYearRange } from "utils/date-format";
import {
  formatTaxAuthority,
  transformEntityForDisplay,
} from "components/gaiaobject-name/GaiaobjectName";

export function getAuditName(props: AuditNameProps) {
  const {
    country,
    governmentEntity,
    localJurisdiction,
    entity,
    taxType,
    auditStartDateString,
    auditEndDateString,
    auditNameSuffix,
    entityCode,
  } = props;
  if (
    !country &&
    !governmentEntity &&
    !localJurisdiction &&
    entity === undefined &&
    taxType === undefined &&
    (auditStartDateString === undefined || auditStartDateString === "") &&
    (auditEndDateString === undefined || auditEndDateString === "") &&
    (auditNameSuffix === undefined || auditNameSuffix === "")
  )
    return "";

  const taxAuthority = formatTaxAuthority(
    country,
    governmentEntity,
    localJurisdiction,
  );

  const transformedEntity = transformEntityForDisplay(entity, entityCode);
  const suffix = (auditNameSuffix ?? "").trim();
  return `${taxAuthority.trim()} | ${transformedEntity.trim()} | ${(
    taxType?.slice(0, 2) ?? []
  )
    .join(", ")
    .toString()} | ${getYearRange(auditStartDateString, auditEndDateString)}${
    suffix ? ` | ${suffix}` : ""
  }`.trim();
}

const AuditName = (auditNameProps: AuditNameProps) => {
  const auditName = getAuditName(auditNameProps);
  return (
    <FormField
      label="Name"
      description="Name generated based on the entity, tax authority, tax type, audit period, suffix."
    >
      <Input value={auditName} readOnly={true} />
    </FormField>
  );
};
export default AuditName;
